import CourseCompletion from "@api/types/course-completion";

export function getVariant(completion: CourseCompletion) {
  const variantType = completion.courseObject.registrationAttribute ?? "variant";
  return completion.registrationInfo.orderInfo.find((a) => a.code === variantType)?.value;
}
